import React from 'react';
import { Home, Building2, Factory, Zap } from 'lucide-react';
import { Button } from './ui/button';
import { services, companyInfo } from '../data/mock';

const iconMap = {
  Home: Home,
  Building2: Building2,
  Factory: Factory
};

const ServicesSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-16 sm:py-24 relative overflow-hidden" style={{ backgroundColor: '#f7f3ed' }}>
      {/* Decorative Hexagons */}
      <div className="absolute top-10 right-10 opacity-10">
        <div 
          className="w-32 h-32 sm:w-48 sm:h-48"
          style={{
            clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
            backgroundColor: '#d4c19c'
          }}
        />
      </div>
      <div className="absolute bottom-10 left-10 opacity-10">
        <div 
          className="w-24 h-24 sm:w-32 sm:h-32"
          style={{
            clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
            backgroundColor: '#9c7c5e'
          }}
        />
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold mb-4" style={{ backgroundColor: '#3a2a23', color: '#d4c19c' }}>
            <Zap className="w-4 h-4" />
            What We Do
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6" style={{ color: '#3a2a23' }}>
            Our Services
          </h2>
        </div>

        {/* Company Description */}
        <div className="max-w-4xl mx-auto text-center mb-12 sm:mb-16">
          <p className="text-base sm:text-lg leading-relaxed mb-4" style={{ color: '#5c4a3d' }}>
            {companyInfo.description.split('\n\n')[0]}
          </p>
          <p className="text-base sm:text-lg leading-relaxed" style={{ color: '#5c4a3d' }}>
            {companyInfo.description.split('\n\n')[1]}
          </p>
        </div>

        {/* Services Grid - Images Only with Titles */}
        <div className="grid sm:grid-cols-3 gap-6 sm:gap-8 mb-10 sm:mb-12">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="group relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 hover:-translate-y-1 sm:hover:-translate-y-2"
                style={{ 
                  boxShadow: '0 8px 30px rgba(58, 42, 35, 0.12)'
                }}
              >
                {/* Image */}
                <div className="relative h-56 sm:h-72 lg:h-80 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                  />
                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  
                  {/* Title Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                    <div className="flex items-center gap-3">
                      {/* Hexagonal Icon */}
                      <div 
                        className="w-10 h-10 sm:w-12 sm:h-12 relative flex items-center justify-center flex-shrink-0"
                        style={{
                          clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                          backgroundColor: '#d4c19c'
                        }}
                      >
                        <div 
                          className="absolute inset-[2px] flex items-center justify-center"
                          style={{
                            clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                            backgroundColor: '#3a2a23'
                          }}
                        >
                          <IconComponent className="w-4 h-4 sm:w-5 sm:h-5" style={{ color: '#d4c19c' }} />
                        </div>
                      </div>
                      <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">
                        {service.title}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Get a Quote Button */}
        <div className="text-center">
          <Button 
            onClick={scrollToContact}
            className="font-bold px-10 sm:px-14 py-6 sm:py-7 text-base sm:text-lg rounded-xl transition-all duration-300 hover:scale-[1.02]"
            style={{ 
              backgroundColor: '#d4c19c', 
              color: '#2a1f1a',
              boxShadow: '0 10px 30px rgba(212, 193, 156, 0.3)'
            }}
          >
            <Zap className="w-5 h-5 mr-2" />
            Get a Quote
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
